import { DynamicPdfImage, GenericPdfImage, LongDeclarationImage, NoDataImage, RasPolyPackImage,GstSummaryWithoutSku, BatchSummaryPdfImage, PurchaseOrderPdfImage } from "../../../../assets/images"

export const handlePdfImages=(name:string)=>{
    switch (name) {
     case "Ras Polypack": return RasPolyPackImage
     case "Generic Pdf": return GenericPdfImage
     case "Dynamic Pdf": return DynamicPdfImage
     case "Ras Polypack": return RasPolyPackImage
     case "Long Declaration" : return LongDeclarationImage
     case "GST Summary Without SKU" :  return GstSummaryWithoutSku
     case "Batch Summary" : return BatchSummaryPdfImage
     case "Purchase Order" : return PurchaseOrderPdfImage
     default: return NoDataImage
    }
   }